import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useTranslations } from "next-intl";
import { ThemeProvider } from "@emotion/react";
import { BenefitsLegacy, TrustLegacy, StageLegacy, ContentArticle, OffersModule, SearchFormLegacy } from "@silvertours/front-features";
import { Theme } from "@silvertours/front-shared";
import { Body } from "../body";
var GeneralContent = function(_param) {
    var _content = _param.content, article = _content.article, country = _content.attributes.country, feedback = _content.feedback, globalRating = _content.globalRating, introduction = _content.introduction, links = _content.links, location = _content.location, offersByCategory = _content.offersByCategory, stage = _content.stage, primaryHeadline = _content.textContent.primaryHeadline, commonProps = _object_without_properties(_param, [
        "content"
    ]);
    var t = useTranslations("features");
    var translations = t.raw("article");
    var offersTranslations = useTranslations("features.offers");
    var makeSearchHandler = SearchFormLegacy.useSubmitInitialSearch().makeSearchHandler;
    var ref, _content1;
    return /*#__PURE__*/ _jsx(Body, _object_spread({
        title: primaryHeadline,
        stage: /*#__PURE__*/ _jsx(StageLegacy.Stage, {
            content: stage.content
        }),
        content: function(param) {
            var container = param.container, containerModule = param.containerModule, contentModule = param.contentModule;
            var ref1, ref2;
            return [
                containerModule("usp", /*#__PURE__*/ _jsx(BenefitsLegacy.Usp, {
                    rating: globalRating.content
                })),
                containerModule("introduction-content", /*#__PURE__*/ _jsx(ThemeProvider, {
                    theme: Theme.defaultTheme,
                    children: /*#__PURE__*/ _jsx(ContentArticle, {
                        modules: (ref = introduction === null || introduction === void 0 ? void 0 : introduction.segments) !== null && ref !== void 0 ? ref : [],
                        translations: translations
                    })
                }), !!(introduction === null || introduction === void 0 ? void 0 : introduction.segments)),
                container("intro", [
                    contentModule("offers", /*#__PURE__*/ _jsx(ThemeProvider, {
                        theme: Theme.defaultTheme,
                        children: !!offersByCategory.content && /*#__PURE__*/ _jsx(OffersModule, {
                            content: offersByCategory.content,
                            onClick: makeSearchHandler((ref1 = stage.content.search) === null || ref1 === void 0 ? void 0 : ref1.location),
                            translations: {
                                badgeText: offersTranslations("badge"),
                                disclaimer: offersTranslations("disclaimerLocation"),
                                disclaimerOverlayCTA: offersTranslations("disclaimerOverlayCTA"),
                                durationFrom: offersTranslations("durationFrom"),
                                headline: "".concat(offersTranslations("headlineLocation"), " ").concat(location.name),
                                pricePrefix: offersTranslations("pricePrefix"),
                                priceSuffix: offersTranslations("priceSuffix"),
                                searchButtonText: offersTranslations("searchButtonText"),
                                offerDetailsTitle: offersTranslations("offerDetailsTitle"),
                                carTypes: t.raw("offers.car.type")
                            }
                        })
                    }), !!offersByCategory.content && Object.keys(offersByCategory.content).length > 0 && !country), 
                ]),
                containerModule("feedbacks", (feedback === null || feedback === void 0 ? void 0 : (ref2 = feedback.content) === null || ref2 === void 0 ? void 0 : ref2.items.length) ? /*#__PURE__*/ _jsx(TrustLegacy.Feedback, _object_spread_props(_object_spread({}, feedback.content), {
                    locationName: location.name
                })) : null),
                container("lists", [
                    contentModule("value-propositions", /*#__PURE__*/ _jsx(BenefitsLegacy.ValuePropositions, {})), 
                ]),
                containerModule("article", /*#__PURE__*/ _jsx(ThemeProvider, {
                    theme: Theme.defaultTheme,
                    children: /*#__PURE__*/ _jsx(ContentArticle, {
                        modules: article.segments,
                        translations: translations
                    })
                })),
                containerModule("linkLists", /*#__PURE__*/ _jsx(ThemeProvider, {
                    theme: Theme.defaultTheme,
                    children: /*#__PURE__*/ _jsx(ContentArticle, {
                        modules: (_content1 = links.content) !== null && _content1 !== void 0 ? _content1 : [],
                        translations: translations
                    })
                })), 
            ];
        }
    }, commonProps));
};
export { GeneralContent };
